import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step456401Meta extends BaseModel {
  hasSpecificDistributions?: boolean;

  constructor(model: Partial<Step456401Meta> = {}) {
    super();

    this.hasSpecificDistributions = model.hasSpecificDistributions;
  }
}
